// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cover-thumb[data-v-71f63f9c]{display:block;max-height:100px;max-width:180px;margin:8px 0}", ""]);
// Exports
module.exports = exports;
